import type { IInputFloatModelValueType, IInputFloatPropsWithoutModelValue } from '@/components';
import { reactive, type Ref } from 'vue';
import { DropdownItemBase } from './DropdownItemBase';

type IDropdownItemFloatInput = {
    [K in keyof IInputFloatPropsWithoutModelValue]: undefined extends IInputFloatPropsWithoutModelValue[K]
        ? IInputFloatPropsWithoutModelValue[K] | Ref<Exclude<IInputFloatPropsWithoutModelValue[K], undefined>> | undefined
        : IInputFloatPropsWithoutModelValue[K] | Ref<IInputFloatPropsWithoutModelValue[K]>;
};

// TODO: I guess this could be a generic class with a PropsType and a modelValue type7
// I'm not sure how to make a type with generics tho
export class DropdownItemFloatInput extends DropdownItemBase {
    modelValue: Ref<IInputFloatModelValueType>;

    props: IInputFloatPropsWithoutModelValue;

    get uniqueLoopKey() {
        return `${this.props.id}-${this.props.label}-${this.props.placeholder}-${this.props.icon}`;
    }

    private abuseBlocker: boolean = false;

    private constructor(modelValue: Ref<IInputFloatModelValueType>, props: IDropdownItemFloatInput, hideDropDownItem?: Ref<boolean>) {
        super();
        this.modelValue = modelValue;
        this.hideDropDownItem = hideDropDownItem;

        this.props = reactive(props);
    }

    public static create(
        options: { modelValue: Ref<IInputFloatModelValueType> } & IDropdownItemFloatInput & Pick<DropdownItemBase, 'hideDropDownItem'>,
    ): DropdownItemFloatInput {
        const { modelValue, hideDropDownItem, ...props } = options;
        return new DropdownItemFloatInput(modelValue, props, hideDropDownItem);
    }
}
